"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
class ResourceList {
    constructor(data, fetchMore, cursor) {
        this.data = data;
        this.fetchMore = fetchMore;
        this.cursor = cursor;
    }
    async nextPage() {
        if (!this.fetchMore) {
            throw new Error('fetchMore is undefined');
        }
        return this.fetchMore({ cursor: this.cursor });
    }
    get hasMore() {
        return !!this.cursor && !!this.fetchMore;
    }
    [Symbol.asyncIterator]() {
        return __asyncGenerator(this, arguments, function* _a() {
            for (const item of this.data) {
                yield yield __await(item);
            }
            if (!this.fetchMore || !this.cursor)
                return yield __await(void 0);
            yield __await(yield* __asyncDelegator(__asyncValues(yield __await(this.fetchMore({ cursor: this.cursor })))));
        });
    }
    async take(count) {
        if (!this.takeIterator) {
            this.takeIterator = this[Symbol.asyncIterator]();
        }
        const values = [];
        while (values.length < count) {
            const { value, done } = await this.takeIterator.next();
            if (value !== undefined)
                values.push(value);
            if (done)
                return values;
        }
        return values;
    }
    takeReset() {
        this.takeIterator = undefined;
    }
    async takeJSON(count) {
        const values = await this.take(count);
        return values.map((d) => d.data);
    }
}
exports.default = ResourceList;
//# sourceMappingURL=ResourceList.js.map